import { z } from 'zod'
import type { PersonView } from './review'

/**
 * Export history (P-RPT-003, D-11): every CSV and print-HTML export is in
 * `export_log`; single-record JSON downloads are in `record_downloads`. Both
 * carry the actor, scope, row count and SHA-256 of the stored file.
 */
export const EXPORT_LOG_FORMATS = ['csv', 'html', 'json'] as const
export type ExportLogFormat = (typeof EXPORT_LOG_FORMATS)[number]

export const exportLogQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(25),
  cursor: z.string().max(1024).optional(),
})
export type ExportLogQuery = z.infer<typeof exportLogQuerySchema>

export interface ExportLogEntry {
  id: string
  kind: string
  format: ExportLogFormat
  row_count: number
  sha256: string
  created_at: string
  /** Staff see the user id too; investors get the display name only (P-ID-006). */
  actor: PersonView | null
  org: { id: string; name: string } | null
  /** The parameters the export ran with. */
  scope: Record<string, unknown>
  /** Single-record downloads only. */
  record_id: string | null
}

/** Body of `GET /exports/records/:kind/:id` (a JSON attachment). */
export interface RecordDownload {
  kind: string
  id: string
  exported_at: string
  prepared_for: string
  classification: string
  record: Record<string, string | number | boolean | null>
}
